import { render, staticRenderFns } from "./VideoPredeterminado.vue?vue&type=template&id=a309f9a6&scoped=true&"
import script from "./VideoPredeterminado.vue?vue&type=script&lang=js&"
export * from "./VideoPredeterminado.vue?vue&type=script&lang=js&"
import style0 from "./VideoPredeterminado.vue?vue&type=style&index=0&id=a309f9a6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a309f9a6",
  null
  
)

export default component.exports